import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LangCodes } from './types';
import { detectLanguage } from './utils';

export const buildI18nResources = (
    enGBTranslations: any,
    enUSTranslations: any,
) => ({
    [LangCodes.GB]: { translation: enGBTranslations },
    [LangCodes.US]: { translation: enUSTranslations },
});

export const initI18n = (resources: Record<LangCodes, any>) => {
    return i18n.use(initReactI18next).init({
        fallbackLng: LangCodes.GB,
        lng: detectLanguage(),
        resources,
        interpolation: {
            escapeValue: false,
        },
    });
};
